module.exports = __webpack_public_path__ + "static/media/prototype_banner_img2.37f5848d.png";